import { ApolloProvider } from 'core/net/ApolloProvider';
import { FETCH_WEATHER_PROCESS_SCHEMA_PROCESS_VARIABLES } from './graphql/facility.fetchWeatherProcessSchemaProcessVariables';
import {
  FetchWeatherProcessSchemaProcessVariablesQuery,
  FetchWeatherProcessSchemaProcessVariablesQueryVariables,
} from 'app/__generated__/global';
import Guid from 'core/types/Guid';

export const fetchWeatherProcessSchemaProcessVariables = async ({
  monitorIds,
  timeBetween,
}: {
  monitorIds: Guid[];
  timeBetween: {
    startTime: string;
    endTime: string;
  };
}) => {
  const { data, error } = await ApolloProvider.global().query<
    FetchWeatherProcessSchemaProcessVariablesQuery,
    FetchWeatherProcessSchemaProcessVariablesQueryVariables
  >({
    query: FETCH_WEATHER_PROCESS_SCHEMA_PROCESS_VARIABLES,
    variables: {
      processSchemaFilter: {
        processId_in: monitorIds,
      },
      variableDataFilter: {
        endTime_between: timeBetween,
      },
    },
  });
  if (!data || error)
    throw new Error('Something went wrong when trying to fetch weather process schema process variables');
  return (
    data?.facility?.processSchemas?.flatMap(processSchema => {
      if (processSchema.__typename !== 'WeatherProcessSchema') return [];
      return {
        id: processSchema.id,
        name: processSchema.name,
        processId: processSchema.process.id,
        processVariables:
          processSchema.weatherSampleGroups?.flatMap(sampleGroup => {
            const sampleRate = sampleGroup.sampleRate;
            return (
              sampleGroup.components?.map(({ component, processVariable }) => {
                return {
                  component,
                  id: processVariable?.id,
                  name: processVariable?.name,
                  data: processVariable?.variableData?.data,
                  type: processVariable?.type,
                  displayUnit: {
                    id: processVariable?.displayUnit?.id,
                    name: processVariable?.displayUnit?.name,
                  },
                  sampleRate,
                };
              }) ?? []
            );
          }) ?? [],
      };
    }) ?? []
  );
};
